import React from "react";
import useAuth from "app/hooks/useAuth";
import { Navigate } from "react-router-dom";
import LandingPage from "app/views/landing_page/LandingPage";
import { AppRoutes } from "app/utils/global_constants";

function RedirectOnRole() {
  const { user } = useAuth();

  if (user?.role === "SA" || user?.role === "company") {
    return <Navigate to={AppRoutes.ROUTE_DASHBOARD} replace />;
  }

  return <LandingPage />;
}

export default RedirectOnRole;
